var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_49_174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 7.5C4.14782 7.5 4.52936 7.65804 4.81066 7.93934C5.09196 8.22064 5.25 8.60218 5.25 9C5.25 9.39782 5.09196 9.77936 4.81066 10.0607C4.52936 10.342 4.14782 10.5 3.75 10.5C3.35218 10.5 2.97064 10.342 2.68934 10.0607C2.40804 9.77936 2.25 9.39782 2.25 9C2.25 8.60218 2.40804 8.22064 2.68934 7.93934C2.97064 7.65804 3.35218 7.5 3.75 7.5ZM9 7.5C9.39782 7.5 9.77936 7.65804 10.0607 7.93934C10.342 8.22064 10.5 8.60218 10.5 9C10.5 9.39782 10.342 9.77936 10.0607 10.0607C9.77936 10.342 9.39782 10.5 9 10.5C8.60218 10.5 8.22064 10.342 7.93934 10.0607C7.65804 9.77936 7.5 9.39782 7.5 9C7.5 8.60218 7.65804 8.22064 7.93934 7.93934C8.22064 7.65804 8.60218 7.5 9 7.5ZM14.25 7.5C14.6478 7.5 15.0294 7.65804 15.3107 7.93934C15.592 8.22064 15.75 8.60218 15.75 9C15.75 9.39782 15.592 9.77936 15.3107 10.0607C15.0294 10.342 14.6478 10.5 14.25 10.5C13.8522 10.5 13.4706 10.342 13.1893 10.0607C12.908 9.77936 12.75 9.39782 12.75 9C12.75 8.60218 12.908 8.22064 13.1893 7.93934C13.4706 7.65804 13.8522 7.5 14.25 7.5Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_49_174"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.b2235813c69340dba4dae2621198116e.svg";
export { ForwardRef as ReactComponent };